import React from "react";
import Logo from "../../assets/logo.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout, Button, Space, Dropdown, Avatar, Grid } from "antd";
import {
  HomeOutlined,
  ProfileOutlined,
  InfoCircleOutlined,
  EditOutlined,
  LogoutOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import "./index.css";

const { Header } = Layout;
const { useBreakpoint } = Grid;

export default function AppHeader({ loggedInUser, onLogout }) {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const menuItems = [{ key: "logout", icon: <LogoutOutlined />, label: "退出登录", onClick: onLogout }];

  const isActive = (path) => (path === "/" ? pathname === "/" : pathname.startsWith(path));

  return (
    <Header className="app-header">
      <div className="app-header-inner">
        <div className="brand" onClick={() => nav("/")} role="button" tabIndex={0}>
          <span className="brand-dot" />
          {!isMobile && <span className="brand-text">MY BLOG</span>}
        </div>

        <div className="nav">
          <Space size={8}>
            <Button
              type={isActive("/") ? "primary" : "default"}
              icon={<HomeOutlined />}
              onClick={() => nav("/")}
            >
              {!isMobile && "首页"}
            </Button>
            <Button
              type={isActive("/archive") ? "primary" : "default"}
              icon={<ProfileOutlined />}
              onClick={() => nav("/archive")}
            >
              {!isMobile && "归档"}
            </Button>
            <Button
              type={isActive("/about") ? "primary" : "default"}
              icon={<InfoCircleOutlined />}
              onClick={() => nav("/about")}
            >
              {!isMobile && "关于"}
            </Button>
          </Space>
        </div>

        <div className="actions">
          <Space size={8}>
            <Button type="primary" icon={<EditOutlined />} onClick={() => nav("/write")}>
              {!isMobile && "写文章"}
            </Button>

            {loggedInUser ? (
              <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                <Space className="user-chip">
                  <Avatar size="small" src={Logo} />
                  {!isMobile && <span className="user-name">{loggedInUser.name}</span>}
                </Space>
              </Dropdown>
            ) : (
              <Button icon={<LoginOutlined />} onClick={() => nav("/auth")}>
                {!isMobile && "登录"}
              </Button>
            )}
          </Space>
        </div>
      </div>
    </Header>
  );
}
